module.exports = __webpack_public_path__ + "static/media/woman-looking-up.90e93e65.jpg";